'use strict';

/* Footer Controller */

angular.module('game').controller('footerCtrl', ['$scope', '$rootScope', 'gameSettings',
  function ($scope, $rootScope, gameSettings) {


    $scope.config = gameSettings;


  }
]);
